export const discoveryContent = {
  meta: {
    title: "Book a Discovery Call — ConX Orbit",
    description:
      "Tell us about the workflow, bottleneck, or idea you're exploring — book a discovery call with ConX Orbit.",
  },
  hero: {
    badge: "BOOK A DISCOVERY CALL",
    title: "Let's Understand What You're Trying to Improve.",
    body: "Tell us about the workflow, bottleneck, or idea you're exploring. We'll use the conversation to understand how your team works and whether AI, automation, or a purpose-built system can make a meaningful difference.",
  },
  form: {
    badge: "DISCOVERY REQUEST",
    status: "FOUNDER-REVIEWED",
    fields: {
      name: "FULL NAME",
      namePlaceholder: "Your name",
      email: "WORK EMAIL",
      emailPlaceholder: "you@company.com",
      company: "COMPANY",
      companyPlaceholder: "Company name",
      role: "YOUR ROLE",
      rolePlaceholder: "e.g. Director, Project Manager, Engineer",
      industry: "INDUSTRY / TRADE",
      industryPlaceholder: "Select an industry or trade",
    },
    industries: [
      "Façade & Curtain Walls",
      "Aluminium",
      "Construction",
      "Electrical",
      "Engineering",
      "Project Operations",
      "Other",
    ],
    topicsLabel: "WHAT WOULD YOU LIKE TO DISCUSS?",
    topics: [
      "AI / Automation",
      "Custom Platform",
      "Workflow Analysis",
      "Integration",
      "Not Sure Yet",
    ],
    improveLabel: "WHAT ARE YOU TRYING TO IMPROVE?",
    improvePlaceholder:
      "Tell us about the workflow, problem, or idea you're exploring...",
    submit: "Book a Discovery Call",
    footnote:
      "We'll review your message before the conversation so we can come prepared.",
    success: "Thanks — we've received your request and will follow up shortly.",
    error: "Something went wrong. Please try again or email us directly.",
  },
  fit: {
    eyebrow: "Is this for you?",
    title: "ConX Orbit Is a Good Fit If...",
    columns: [
      {
        heading: "You're dealing with",
        tone: "problems",
        items: [
          "A workflow that's heavily manual",
          "Information spread across multiple tools",
          "Repetitive document processing",
          "Drawing-heavy processes",
          "Difficult reporting or tracking",
          "A process that doesn't fit existing software",
        ],
      },
      {
        heading: "You're looking for",
        tone: "solutions",
        items: [
          "A purpose-built system",
          "AI-powered automation",
          "Better workflow visibility",
          "Connected project information",
          "A technology partner who understands the problem first",
          "A practical path from idea to working system",
        ],
      },
    ],
  },
};
